export enum MaintenanceTab {
  All = 'all',
  MaintenanceRequests = 'maintenanceRequests',
  UpcomingMaintenances = 'upcomingMaintenances',
  OverdueMaintenances = 'overdueMaintenances',
  CompletedMaintenances = 'completedMaintenances'
}

export enum MaintenanceModelFilter {
  All = 0,
  OEM = 1,
  CanBus = 2,
  Compliance = 3,
  DriverAssisted = 4
}

export enum MaintenanceEventType {
  Preventative = 'Preventative',
  Reactive = 'Reactive'
}